<template>
  <div class="w-full">

    <div class="px-5 pt-7 pb-2">


      <jet-validation-errors class="mb-4"/>

      <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
        {{ status }}
      </div>

      <form @submit.prevent="submit">
        <div>
          <jet-label for="email" value="Email"/>
          <jet-input id="email" type="email" class="mt-1 block w-full"
                     v-model="form.email" required autofocus/>
        </div>

        <div class="mt-4">
          <jet-label for="password" value="Password"/>
          <jet-input id="password" type="password"
                     class="mt-1 block w-full" v-model="form.password" required autocomplete="current-password"/>
        </div>

        <div class="block mt-4">
          <label class="flex items-center">
            <jet-checkbox name="remember" v-model:checked="form.remember"/>
            <span class="ml-2 text-sm text-gray-600">Remember me</span>
          </label>
        </div>


        <button
            type="submit"
            :class="{ 'opacity-25': form.processing }" :disabled="form.processing"
            class="
            mt-2
                rounded-full
                transition
                duration-200
                bg-blue-500
                hover:bg-blue-300
                focus:border-blue-100
                text-white
                w-full
                py-2.5
                rounded-lg
                text-lg
                font-semibold
                text-center
                inline-block
              "
        >
          <span class="inline-block mr-2">Sign in</span>
        </button>
      </form>

      <div class="mt-2 w-full py-2.5 ">
        <sign-in-with-slack-button></sign-in-with-slack-button>
      </div>
      <div class="w-full py-2 ">
        <sign-in-with-google-button></sign-in-with-google-button>
      </div>
    </div>
    <div class="py-5">
      <div class="grid grid-cols-2 gap-1">
        <div class="text-center sm:text-left whitespace-nowrap">
          <button
              @click=" this.$inertia.visit(route('register'))"
              class="
                    transition
                    duration-200
                    mx-5
                    px-5
                    py-4
                    cursor-pointer
                    font-normal
                    text-lg
                    rounded-lg
                    text-blue-500
                    focus:outline-none
                    ring-inset
                  "
          >
                  <span
                      class="
                      text-blue-500
                      font-bold
                      inline-block
                      ml-1
                      hover:text-blue-300
                    "
                  >Create account</span
                  >
          </button>
        </div>
        <div class="text-center sm:text-right whitespace-nowrap">
          <button
              @click=" this.$inertia.visit(route('password.request'))"
              class="
                    transition
                    duration-200
                    mx-5
                    px-5
                    py-4
                    cursor-pointer
                    font-normal
                    text-lg
                    rounded-lg
                    text-blue-500
                    focus:outline-none
                    ring-inset
                  "
          >
                  <span
                      class="
                      text-blue-500
                      font-bold
                      inline-block
                      ml-1
                      hover:text-blue-300
                    "
                  >Forgot?</span
                  >
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard'
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo'
import JetButton from '@/Jetstream/Button'
import JetInput from '@/Jetstream/Input'
import JetCheckbox from '@/Jetstream/Checkbox'
import JetLabel from '@/Jetstream/Label'
import JetValidationErrors from '@/Jetstream/ValidationErrors'
import {message} from "ant-design-vue";
import SignInWithSlackButton from "@/Components/SocialButton/SignInWithSlackButton";
import SignInWithGoogleButton from "@/Components/SocialButton/SignInWithGoogleButton";

export default {
  components: {
    SignInWithGoogleButton,
    SignInWithSlackButton,
    JetAuthenticationCard,
    JetAuthenticationCardLogo,
    JetButton,
    JetInput,
    JetCheckbox,
    JetLabel,
    JetValidationErrors
  },

  props: {
    canResetPassword: Boolean,
    status: String
  },

  data() {
    return {
      form: this.$inertia.form({
        email: '',
        password: '',
        remember: false
      })
    }
  },

  methods: {
    submit() {
      let app = this;
      const currentLocation = window.location.href;
      this.form
          .transform(data => ({
            ...data,
            remember: this.form.remember ? 'on' : ''
          }))
          .post(this.route('login'), {
            onFinish: () => this.form.reset('password'),
            onSuccess: () => {
              window.location.href = currentLocation;
              message.success("My friend, welcome back.", 3);
            },
          })
    }
  }
}
</script>
